import { technology_stack_data } from '@apps/data/technology_stack_data';
import React from 'react';
import { SectionHeader } from '@apps/components/section-header';

export const TechnologyStackItem = ({title}) => {
  return (
    <section className={`container pb-[50px] lg:pt-[50px] lg:pb-[100px] ${title ? 'bg-jacarta-900' : 'bg-[#101436]'}`}>
      {title && (
          <SectionHeader title={"Technologies we use"} subTitle={"Our technical prowess spans a multitude of blockchain platforms, allowing us to deliver solutions tailored to your business needs:"}/>
      )}
      <div className={'grid grid-cols-1 w-100'}>
        {technology_stack_data.map((val, index) => (
          <div key={index} className={'border-b-2 cols-span-12 gap-y-8 grid-cols-1 md:grid-cols-3 grid py-4 items-center'}
               style={{ borderColor: '#312C37' }}>
            <div className='col-span-1 font-medium flex justify-center md:justify-start'>
              <h3 className='text-[20px] text-center md:text-left'>{val.title}</h3>
            </div>
            <div className='col-span-1 md:col-span-2 md:px-6 lg:px-8'>
              <div className='grid gap-y-12 grid-cols-8 lg:grid-cols-10 xl:grid-cols-12'>
                {val.tech.map((text, i) => (
                  <div class={'col-span-2'} key={i}>
                    <a
                      className='flex flex-col gap-5 w-full whitespace-nowrap bg-transparent items-center gap-3 text-sm font-normal text-neutral-700 transition duration-300 ease-in-out hover:bg-neutral-50 active:text-neutral-800 active:no-underline disabled:pointer-events-none disabled:bg-transparent disabled:text-neutral-400 dark:text-neutral-200 dark:hover:bg-neutral-600'
                      href='#'>
                      {typeof text.icon === "string" ? (
                        <svg className='icon h-9 w-9'>
                          <use xlinkHref={`/icons.svg#${text.icon}`} />
                        </svg>
                      ) : (
                        <img className='icon h-9 w-9' src={text.icon.src}/>
                      )}
                      <span className='text-[14px] text-jacarta-300'>{text.name}</span>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
